
  import { NAVIGATION } from '~/constants/navigation';

  export default {
    data () {
      return { menuOpen: false, selectedCategory: null };
    },
    computed: {
      disableNavMenu () {
        return ((this.meta && this.meta.disableNav) || this.$route.path.includes('results'));
      },
      meta () {
        return this.$store.getters['utils/getMeta'];
      },
      navigation () {
        return NAVIGATION;
      },
      profileImage () {
        return this.user.profile_image;
      },
      user () {
        return this.$store.getters['user/get'];
      },
      userFullName () {
        return this.$store.getters['user/getFullName'];
      }
    },
    watch: {
      menuOpen () {
        const bodyEl = document.getElementsByTagName('BODY')[0];
        if (this.menuOpen === true) {
          bodyEl.style.overflowY = 'hidden';
        } else {
          bodyEl.style.overflowY = 'visible';
        }
      },
      '$route.path' () {
        this.menuOpen = false;
      }
    },
    methods: {
      goToMyAccount () {
        if (!this.user) return;
        this.menuOpen = false;
        this.$router.push('/account/profile/');
      },
      newProductBadge (key) {
        if (key === 'ci' || key === 'hi' || key === 'ip' || key === 'll') {
          return true;
        } else {
          return false;
        }
      },
      toggleCategory (category) {
        this.selectedCategory = (this.selectedCategory === category) ? null : category;
      }
    }

  };
